/*
 * @Author: GRANDSOFT\chenz-k chenz-k@glodon.com
 * @Date: 2022-10-27 10:16:59
 * @LastEditors: GRANDSOFT\chenz-k chenz-k@glodon.com
 * @LastEditTime: 2023-04-23 10:49:56
 * @FilePath: \shared-portal-web\packages\info\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Info from '../views/info'

const routes = [
  {
    path: '/',
    name: 'Info',
    component: Info,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'LandHome',
        component: () => import(/* webpackChunkName:'info' */'../views/info/components/land-main/land-home/LandHome.vue')
      },
      {
        path: 'developer',
        name: 'LandSolutionDeveloper',
        component: () => import(/* webpackChunkName:'info' */'../views/info/components/land-main/land-solution/LandSolutionConstruction.vue')
      },
      {
        path: 'contractor',
        name: 'LandSolutionContractor',
        component: () => import(/* webpackChunkName:'info' */'../views/info/components/land-main/land-solution/LandSolutionProduction.vue')
      },
      {
        path: 'application',
        name: 'LandApplication',
        component: () => import(/* webpackChunkName:'info' */'../views/info/components/land-main/land-application/LandApplication.vue')
      },
      {
        path: 'dynamic',
        name: 'LandDynamic',
        component: () => import(/* webpackChunkName:'info' */'../views/info/components/land-main/land-dynamic/LandDynamic.vue')
      }
      // {
      //   path: 'understand',
      //   name: 'LandUnderstand',
      //   component: () => import(/* webpackChunkName:'info' */'../views/land-page/components/land-main/land-understand/LandUnderstand.vue')
      // }
    ]
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import(/* webpackChunkName:'info' */'../views/info/components/user-center/agreement.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName:'info' */'../views/info/components/user-center/privacy.vue')
  }
]

export default routes
